export const rideTabs: Array<{ title: string }> = [
  {
    title: 'detail',
  },
  {
    title: 'notes',
  },
  {
    title: 'audit log',
  },
  {
    title: 'route',
  },
  {
    title: 'transmit',
  },
];

export const soTabs: Array<{ title: string }> = [
  {
    title: 'detail',
  },
  {
    title: 'notes',
  },
  {
    title: 'audit log',
  },
];

export const RIDE_TABS = (isContractorVersion: boolean) =>
  !isContractorVersion
    ? rideTabs
    : [
        ...rideTabs,
        {
          title: 'equipment',
        },
      ];

export const fixData = [
  {
    distance: { value: 0 },
    duration: { value: 0 },
  },
];

export const finalDestinationDefault = {
  id: 101,
  value: 'Final Destination',
  label: 'Final Destination',
};

export const returnRideService = {
  id: 100,
  value: 'Return ride',
  label: 'Return ride',
};

export const resetObject = {
  id: 0,
  value: '',
  label: '',
};

export const rideSegmentDefault = {
  scheduledPickupTime: null,
  pickupLocations: {
    id: Infinity,
  },
  dropOffLocation: {
    id: Infinity,
  },
  pickUpContactPhoneExt: '',
  dropOffContactPhoneExt: '',
  contractor: null,
  estMiles: '',
  pickupLocationShortNote: '',
  pickUpContactPhone: '',
  pickUpContactPhoneType: '',
  dropOffContactPhone: '',
  dropOffContactPhoneType: '',
  estimatedTripDuration: '',
  status: {
    id: 100,
    label: 'New',
    value: 'New',
  },
  authorization: {
    id: 0,
    label: '',
    value: '',
  },
  scheduledAppointmentTime: null,
  timesRecordId: 0,
  callIndicator: false,
  rideDate: '',
  lettering: '',
  nextDay: false,
};

export const defaultValues = {
  modeOfTransport: {
    id: 0,
    label: '',
    value: '',
  },
  scheduledDays: [],
  authorizedNumber: '',
  relation: null,
  startDate: '',
  endDate: '',
  schedulerAuthorizedContact: '',
  callBackNumber: '',
  smsIndicator: '',
  extraPassenger: {
    id: 0,
    label: '0',
    value: '0',
  },
  totalDuration: '',
  totalMile: '',
  ridesTags: [],
  ridesSegments: [rideSegmentDefault],
};

export const defaultAppendValue = {
  scheduledPickupTime: null,
  pickupLocations: {
    id: Infinity,
  },
  dropOffLocation: {
    id: Infinity,
  },
  ext: '',
  contractor: null,
  estMiles: '',
  pickupLocationShortNote: '',
  pickUpContactPhone: '',
  pickUpContactPhoneType: '',
  dropOffContactPhone: '',
  dropOffContactPhoneType: '',
  estimatedTripDuration: '',
  status: finalDestinationDefault,
  authorization: {
    id: 0,
    label: '',
    value: '',
  },
  scheduledAppointmentTime: null,
  timesRecordId: 0,
  callIndicator: false,
  rideDate: '',
  nextDay: false,
  rideType: '',
  rideBody: '',
  priceChangedToken: '',
};

export const extraPassengersObject = [
  {
    id: 0,
    label: '0',
    value: '0',
  },
  {
    id: 1,
    label: '1',
    value: '1',
  },
  {
    id: 2,
    label: '2',
    value: '2',
  },
  {
    id: 3,
    label: '3',
    value: '3',
  },
  {
    id: 4,
    label: '4',
    value: '4',
  },
  {
    id: 5,
    label: '5',
    value: '5',
  },
  {
    id: 6,
    label: '6',
    value: '6',
  },
  {
    id: 7,
    label: '7',
    value: '7',
  },
];

export const daysObject = [
  {
    id: 0,
    label: 'Mon',
    value: 'Mon',
  },
  {
    id: 1,
    label: 'Tue',
    value: 'Tue',
  },
  {
    id: 2,
    label: 'Wed',
    value: 'Wed',
  },
  {
    id: 3,
    label: 'Thu',
    value: 'Thu',
  },
  {
    id: 4,
    label: 'Fri',
    value: 'Fri',
  },
  {
    id: 5,
    label: 'Sat',
    value: 'Sat',
  },
  {
    id: 6,
    label: 'Sun',
    value: 'Sun',
  },
];

// the standing order picker lists the week from Sunday. daysObject itself keeps
// the order the api indexes scheduledDays by, so it must not be reordered.
export const standingOrderDaysObject = [
  daysObject[6],
  ...daysObject.slice(0, 6),
];

export const placesIconsStyles = [
  {
    featureType: 'poi',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.business',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'landscape',
    stylers: [{ visibility: 'simplified' }],
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'transit',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'water',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
  {
    elementType: 'geometry',
    stylers: [{ color: '#1d2c4d' }],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [{ color: '#8ec3b9' }],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#1a3646' }],
  },
  {
    featureType: 'administrative.country',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#4b6878' }],
  },
  {
    featureType: 'administrative.land_parcel',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#d3d3d3' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry.fill',
    stylers: [{ color: '#023e58' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#3f6090' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{ color: '#304a7d' }],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#98a5be' }],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#1d2c4d' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{ color: '#2c6675' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#255763' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#b0d5ce' }],
  },
  {
    featureType: 'transit',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#98a5be' }],
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [{ color: '#3f518c' }],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: '#0e1626' }],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#4e6d70' }],
  },
];
